var exports = {
  "Qs": "xfd349460--32c23e--content",
  "su": "xfd349460--32c23e--icon-wrapper",
  "R_": "xfd349460--32c23e--heading",
  "qr": "xfd349460--32c23e--footer",
};

module.exports = exports;
